import "@/assets/sass/style.scss";
import "@/../mobile.js";

/**
 * Извлечение конкретного параметра из URL и его значения.
 *
 * @param {String} name
 * @return {String}
 */
function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  let results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 * Если при загрузке страницы была ошибка авторизации - она отобразится сразу.
 */
if (getUrlParameter("error")) {
  document.getElementById("error-message").style.display = "block";
  document.getElementById("error-message").style.opacity = 1;
}
